import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const injectGoogleTag = (measurementId) => {
  if (!measurementId) return;

  // Avoid duplicate injection
  if (!document.getElementById("ga-script")) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.id = "ga-script";
    document.head.appendChild(script);
  }

  // Initialize gtag
  if (!window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
  }
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag(){ window.dataLayer.push(arguments); };
  }

  window.gtag("js", new Date());
  window.gtag("config", measurementId);
};

export default function GoogleAnalytics({ measurementId }) {
  const location = useLocation();
  
  // Default to the GA ID if not provided via env variable
  const gaId = measurementId || "G-BFCZFYGYB8";

  useEffect(() => {
    injectGoogleTag(gaId);
  }, [gaId]);

  // Track route changes as page views
  useEffect(() => {
    if (!gaId) return;
    if (typeof window.gtag === "function") {
      window.gtag("config", gaId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, gaId]);

  return null;
} 